// extracted by mini-css-extract-plugin
export var button = "_o-0";
export var buttonContent = "_o-e";
export var buttonGroup = "_o-c";
export var dontRestrainIconWidth = "_o-a";
export var dropdownButton = "_o-b";
export var iconContainer = "_o-9";
export var lg = "_o-4";
export var md = "_o-3";
export var pending = "_o-f";
export var sm = "_o-2";
export var spinner = "_o-d";
export var squared = "_o-8";
export var wrapText = "_o-g";
export var xl = "_o-5";
export var xs = "_o-1";
export var xxl = "_o-6";
export var xxxl = "_o-7";